application.register("layout_header", class extends Stimulus.Controller {
    connect() {

        this._offset = 20;
        this._ticking = false;

        if(document.documentElement.querySelector("#page") !== null) {
            this._offset = document.documentElement.querySelector("#page").offsetTop + 20;
        }

        window.addEventListener('scroll', ()=>{
            this.onScroll(window.scrollY);
        }, false);
    }

    disconnect() {
        window.removeEventListener('scroll', ()=>{
            this.onScroll(window.scrollY);
        }, false);
    }

    toggleMenu(e) {
        e.preventDefault();
        e.currentTarget.classList.toggle("icon-close");
        document.body.classList.toggle("no-scroll-nav");

        document.querySelector(".header-nav").classList.toggle("active");

        this.element.querySelector(".header").classList.toggle("active");
    }

    onScroll(currentScrollY) {
        if (!this._ticking) {
            requestAnimationFrame(() => {
                if(currentScrollY > this._offset) {
                    this.element.querySelector(".header").classList.add("fixed");
                }
                else {
                    this.element.querySelector(".header").classList.remove("fixed");
                }
            });
            this._ticking = false;
        } else {
            this._ticking = true;
        }
    }
});